var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BackgroundCommand } from '@reference-data/background-message-key.enum';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const initBackgroundAutolock = () => __awaiter(void 0, void 0, void 0, function* () {
    let autolock = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.AUTOLOCK);
    chrome.runtime.sendMessage({
        command: BackgroundCommand.UPDATE_AUTOLOCK,
        value: Object.assign({}, autolock),
    });
});
const AutolockUtils = {
    initBackgroundAutolock,
};
export default AutolockUtils;
